export default "__VITE_ASSET__DXFmu57C__";